<mat-card class="p-0">
    <mat-tab-group [selectedIndex]="0">
        <!-- Experience Tab -->
        <mat-tab label="Experience">
            <form #benExpForm="ngForm" class="w-100">
                <div class="row">
                    <div class="form-group col-md-4">
                        <label class="label-cls">Company Name</label>
                        <input class="im-input mw-100" type="text" name="companyName"
                            [(ngModel)]="beneficiaryWorkDetails.companyName" placeholder="Enter"
                            #companyName="ngModel" />
                    </div>
                    <div class="form-group col-md-4">
                        <label class="label-cls">Title</label>
                        <input class="im-input mb-2 mw-100" type="text" name="designation"
                            [(ngModel)]="beneficiaryWorkDetails.designation" placeholder="Enter"
                            #designation="ngModel" />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12">
                        <mat-checkbox name="isCurrentRole" [(ngModel)]="beneficiaryWorkDetails.isCurrentRole">
                            I am currently working in this role
                        </mat-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-3">
                        <label class="label-cls">Employed From</label>
                        <div class="mt-1">
                            <mat-form-field appearance="outline" class="w-100 date-field">
                                <input matInput [matDatepicker]="employedFromPicker" name="startDate"
                                    [(ngModel)]="beneficiaryWorkDetails.startDate" placeholder="MM/DD/YYYY"
                                    #startDt="ngModel" [max]="maxDate" (click)="employedFromPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="employedFromPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #employedFromPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group col-md-3" *ngIf="!beneficiaryWorkDetails.isCurrentRole">
                        <label class="label-cls">Employed Till</label>
                        <div class="mt-1">
                            <mat-form-field appearance="outline" class="w-100 date-field">
                                <input matInput [matDatepicker]="employedTillPicker" name="endDate"
                                    [(ngModel)]="beneficiaryWorkDetails.endDate"
                                    [min]="beneficiaryWorkDetails.startDate" [max]="maxDate" placeholder="MM/DD/YYYY"
                                    (click)="employedTillPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="employedTillPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #employedTillPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>



                    <div class="form-group col-md-3">
                        <label class="label-cls">Scheduled Weekly Hours</label>
                        <div class="mt-1">
                            <input class="im-input mb-2 mw-100" type="text" name="scheduledWeeklyHours"
                            [(ngModel)]="beneficiaryWorkDetails.scheduledWeeklyHours" placeholder="Enter"
                            #scheduledWeeklyHours="ngModel" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <button class="btn btn-success" (click)="saveEmployment(benExpForm)">
                                <i class="fa fa-floppy-o" aria-hidden="true"></i> Save & More 
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <div class="table-section">Experience</div>


            <table mat-table #table [dataSource]="dataSource" class="full-width-table" matSort aria-label="Elements">

                <ng-container matColumnDef="companyName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
                    <td mat-cell *matCellDef="let row">{{row.companyName}}</td>
                </ng-container>

                <ng-container matColumnDef="designation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
                    <td mat-cell *matCellDef="let row">{{row.designation}}</td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                    <td mat-cell *matCellDef="let row">{{row?.startDate ? (row.startDate| ImgDateFormat) : '--'}}</td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                    <td mat-cell *matCellDef="let row">{{row?.endDate ? (row.endDate| ImgDateFormat) : '--'}}</td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                    <td mat-cell *matCellDef="let row">
                        <i class="fa fa-pencil" aria-hidden="true" title="Edit" (click)="editExperience(row)"></i>
                        <i class="fa fa-trash-o" aria-hidden="true" title="Delete" (click)="deleteExperience(row)"></i>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            
            <div class="no-record" *ngIf="dataSource === null || dataSource.length === 0">No record found</div>
            
        </mat-tab>

        <!-- Documnet Upload Tab -->
        <mat-tab label="Upload Documents" [disabled]="!experienceFileUploadConfigurations?.entityId">
            <div class="row">
                <div class="col-12">
                    <app-file-upload class="w-100" [configurations]="experienceFileUploadConfigurations"
                        (fileUploadSuccess)="fileUploadSuccess()">
                    </app-file-upload>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card>